"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pathways = [{
  title: "Mobile Tyre Fitting",
  description: "Professional mobile tyre fitting Leeds. We bring the garage to your home, work, or roadside with our fully equipped service vans.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647150/img/mobile_tyre_fitting_leeds.png",
  linkText: "View Services",
  linkUrl: "/TyreServicesPage"
}, {
  title: "Emergency Callouts",
  description: "Stranded with a flat? Our 24/7 emergency tyre fitting Leeds team responds within 30-60 minutes to get you back on the road safely.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647150/img/emergency_roadside_assistance.png",
  linkText: "View Services",
  linkUrl: "/TyreServicesPage"
}, {
  title: "Puncture Repair",
  description: "Expert mobile tyre repair Leeds. If your tyre can be saved, we'll fix it on-site, saving you the cost of a brand new replacement.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647150/img/tyre_puncture_repair.png",
  linkText: "View Services",
  linkUrl: "/TyreServicesPage"
}];
export default function InvestmentPathways() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222915" id="expert-tyre-solutions" className="bg-background text-foreground py-24 md:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        
        <div ref={headerRef} className={`mb-16 md:mb-24 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="font-default text-4xl md:text-6xl lg:text-7xl font-bold tracking-tighter uppercase mb-6">
            Expert Tyre <br className="hidden md:block" /> Solutions
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl font-serif">
            Rapid response mobile tyre fitting across Leeds. Our local experts provide 24/7 support to ensure you're never stranded for long.
          </p>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {pathways.map((pathway, i) => <div key={i} data-index={i} className={`group relative h-[500px] lg:h-[600px] w-full overflow-hidden rounded-lg bg-secondary border border-border/50 transition-all duration-1000 ease-out delay-${i * 100} ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-16"} hover:border-primary/50 hover:shadow-2xl hover:shadow-primary/10`}>
              {}
              <img src={pathway.image} alt={pathway.title} className="absolute inset-0 w-full h-full object-cover transition-all duration-700 ease-in-out grayscale group-hover:grayscale-0 group-hover:scale-105" />
              
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-secondary via-secondary/40 to-transparent transition-opacity duration-500 group-hover:from-secondary/95" />

              {}
              <div className="absolute inset-0 p-8 md:p-10 flex flex-col justify-end">
                {}
                <div className="transform translate-y-[4.5rem] transition-transform duration-500 ease-[cubic-bezier(0.25,1,0.5,1)] group-hover:translate-y-0">
                  
                  <h3 className="font-default text-2xl md:text-3xl font-bold text-white mb-4 uppercase tracking-tight">
                    {pathway.title}
                  </h3>
                  
                  <p className="text-white/80 font-serif text-sm md:text-base mb-8 line-clamp-3">
                    {pathway.description}
                  </p>
                  
                  {}
                  <div className="opacity-0 transition-opacity duration-500 delay-100 group-hover:opacity-100">
                    <Button asChild variant="default" size="lg" className="w-full rounded-full font-bold uppercase tracking-wider bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg shadow-primary/20">
                      <Link to={pathway.linkUrl}>
                        {pathway.linkText}
                        <ArrowRight className="ml-2 size-5" />
                      </Link>
                    </Button>
                  </div>

                </div>
              </div>
            </div>)}
        </div>

      </div>
    </section>;
}